import { mapState } from "vuex";
import menuMixin from "../mixin/menu";
import { elMenuItem, elSubmenu } from "../libs/util.menu";
import BScroll from "better-scroll";

export default {
  name: "d2-layout-header-aside-menu-side",
  mixins: [menuMixin],
  render(createElement) {
    // 递归翻译所有菜单（包括子菜单）
    const translateMenu = item => {
      const translated = {
        ...item,
        title: this.$t(item.title)
      };
      if (item.children) {
        translated.children = item.children.map(child => translateMenu(child));
      }
      return translated;
    };

    // 翻译整个菜单树
    const translatedMenus = this.aside.map(menu => translateMenu(menu));

    return createElement(
      "div",
      { attrs: { class: "d2-layout-header-aside-menu-side" } },
      [
        createElement(
          "el-menu",
          {
            props: {
              collapse: this.asideCollapse,
              uniqueOpened: true,
              defaultActive: this.active
            },
            ref: "menu",
            on: { select: this.handleMenuSelect }
          },
          translatedMenus.map(menu =>
            (menu.children === undefined ? elMenuItem : elSubmenu).call(
              this,
              createElement,
              menu
            )
          )
        ),
        ...(this.aside.length === 0 && !this.asideCollapse
          ? [
              createElement(
                "div",
                {
                  attrs: {
                    class: "d2-layout-header-aside-menu-empty",
                    flex: "dir:top main:center cross:center"
                  }
                },
                [
                  createElement("d2-icon", { props: { name: "inbox" } }),
                  createElement("span", {}, "没有侧栏菜单")
                ]
              )
            ]
          : [])
      ]
    );
  },
  data() {
    return {
      active: "",
      BS: null
    };
  },
  computed: {
    ...mapState("d2admin/menu", ["aside", "asideCollapse"])
  },
  watch: {
    "$i18n.locale"() {
      this.$forceUpdate();
    },
    asideCollapse(val) {
      this.scrollDestroy();
      setTimeout(() => {
        this.scrollInit();
      }, 500);
    },
    "$route.fullPath"() {
      this.active = this.$route.fullPath;
    }
  },
  mounted() {
    this.scrollInit();
  },
  beforeDestroy() {
    this.scrollDestroy();
  },
  methods: {
    scrollInit() {
      this.BS = new BScroll(this.$el, {
        mouseWheel: true,
        click: true
      });
    },
    scrollDestroy() {
      try {
        this.BS.destroy();
      } catch (e) {
        this.BS = null;
      }
    }
  }
};
